import BaseAPI from '../base'

function checkCity(city) {
    return BaseAPI.get(`/marketplace/city/${city}`);
}

function getFlavors() {
    return BaseAPI.get(`/marketplace/flavors`);    
}

function connect(id) {
    return BaseAPI.post(`/marketplace/connect/${id}`);
}

export default {
    checkCity,
    getFlavors,
    connect
}